/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Edit_DescriptionInputs */

const en_admin_roles_edit_description = /** @type {(inputs: Admin_Roles_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update role details`)
};

/**
* | output |
* | --- |
* | "Update role details" |
*
* @param {Admin_Roles_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_edit_description = /** @type {((inputs?: Admin_Roles_Edit_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Edit_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_edit_description(inputs)
});
export { admin_roles_edit_description as "admin.roles.edit_description" }